export default __webpack_public_path__ + "static/media/roadmap.fa42d50c.png";